var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isCreated
    ? _c(
        "div",
        {
          ref: "root",
          staticClass: "c-categories-filter",
          attrs: { id: "v-categories" },
        },
        [
          _vm.selectedCategoryId
            ? _c("div", { staticClass: "c-categories-filter__back" }, [
                _vm.showBackButton
                  ? _c(
                      "button",
                      {
                        staticClass: "c-btn c-btn--categories-back",
                        attrs: { title: _vm.backButtonName },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.back.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "ico ico-caret-left-thick is-on-left",
                        }),
                        _vm._v(" " + _vm._s(_vm.backButtonName) + "\n        "),
                      ]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "c-categories-filter__list" },
            _vm._l(_vm.categories, function (category) {
              return _c(
                "a",
                {
                  key: category.id,
                  class: {
                    "c-link": true,
                    "is-active": category.id == _vm.selectedCategoryId,
                  },
                  attrs: { href: category.link, title: category.name },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.change(category.id)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "is-image" }, [
                    _c("img", {
                      staticClass: "c-img",
                      attrs: {
                        src: _vm.projectThumbnail(category.image, "ret-subcat"),
                        alt: category.name,
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "is-name" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(category.name) +
                        "\n            "
                    ),
                  ]),
                ]
              )
            }),
            0
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }